var BookDisplay = require("components/reading/books/BookDisplay")

class TaskTile extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	onClick() {
		if (this.props.onClick) {
			this.props.onClick(this.props.item);
		}
	}

	isTaskComplete(taskItems) {
		// find finished tasks 
		var finishedQuiz = _.where(taskItems, { subject_type: 'Quiz', draft: false });
		var finishedPracticeQuestions = _.where(taskItems, { subject_type: 'Practice Question', draft: false});
		var finishedReview = _.where(taskItems, { subject_type: 'Review', draft: false });
		// sum completed tasks
		var completed_tasks = finishedQuiz.length + finishedPracticeQuestions.length + finishedReview.length
		// return comparison
		return taskItems.length <= completed_tasks ? true : false;
	}

	daysRemaining(item) {
		if (item.task_items && item.task_items[0].due_date) {
			if (this.isTaskComplete(item.task_items)) {
				return "This task is complete!"
			}
			var today = new Date();
			var dueDate = new Date(item.task_items[0].due_date);
			if (today.getMonth() == 11 && today.getDate() > 25) {
				dueDate.setFullYear(dueDate.getFullYear() + 1);
			}
			var oneDay = 1000 * 60 * 60 * 24;
			var daysRemaining = Math.ceil((dueDate.getTime() - today.getTime()) / (oneDay))
			if (daysRemaining === 0) {
				return 'Due today!'
			}
			else if (daysRemaining > 0) {
				return `${daysRemaining} days left!`
			}
			else {
				return `${Math.abs(daysRemaining)} days late!`
			}
		} else {
			return 'No due date for this task'
		}
	}

	render() {
		var item = this.props.item;
		if (this.props.type == READING_URL_TASK) {
			var taskDisplay = (
				<div className="task" onClick={ this.onClick }>
					<div className="taskTitle">
						<BookDisplay textID={ item.text_id } />
					</div>
					<span className="category">{ this.daysRemaining(this.props.item, this.props.userID) }</span><br/>
					<img src={require("reading/teachers-picks-online.png")} alt="Teacher Pick" />
					<span className="category">Teacher Pick</span>
				</div>
			);

		} else if (this.props.type == READING_TITLE_TASK) {
			var taskDisplay = (
				<div className="task" onClick={ this.onClick }>
					<div className="taskTitle">
						<BookDisplay textID={ item.text_id } />
					</div>
					<span className="category">{ this.daysRemaining(this.props.item, this.props.userID) }</span><br/>
					<img src={require("reading/teachers-picks.png")} alt="Teacher Pick" />					
					<span className="category">Teacher Pick</span>
				</div>
			);

		} else if (this.props.type == EXERCISE_TASK) {
			var taskDisplay = (
				<div className="task" onClick={ this.onClick }>
					<div className="taskTitle">{ item.format_summary.title }</div>
					<span className="category">{ this.daysRemaining(this.props.item, this.props.userID) }</span><br/>
					<img src={require("reading/exercise-small.png")} alt="Do an Exercise" />					
					<span className="category">Exercise</span>
				</div>
			);

		} else if (this.props.type == REVISABLE_TASK) {
			if (this.props.item.type == "quiz") {
				var altText = "Revise your quiz";
				var imgPath = require("action-icons/quizzes-passed.png")

			} else if (this.props.item.type == "answer") {
				var altText = "Revise your answer";
				var imgPath = require("action-icons/questions.png")

			} else if (this.props.item.type == "review") {
				var altText = "Revise your review";
				var imgPath = require("action-icons/reviews.png")

			} else {
				console.error("Unkonwn revisable-task item type: ", this.props.item.type);
			}

			var taskDisplay = (
				<div className="task" onClick={ this.onClick }>
					<div className="taskTitle">
						<BookDisplay textID={ item.text_id } />
					</div>
					<img src={ imgPath } alt={ altText } />
					<span className="category">
						Revision
					</span>
				</div>
			);
		}

		var taskDisplayClass = ''
		if (this.props.gridView) { taskDisplayClass = 'col-sm-4 col-xs-12 text-center'}
		return (
			<div className={taskDisplayClass}>{ taskDisplay }</div>
		);
	}
};

var EXERCISE_TASK = "exercise-task";
var REVISABLE_TASK = "revisable-task";
var READING_TITLE_TASK = "reading-title-task";
var READING_URL_TASK = "reading-url-task";

TaskTile.EXERCISE_TASK = EXERCISE_TASK;
TaskTile.REVISABLE_TASK = REVISABLE_TASK;
TaskTile.READING_TITLE_TASK = READING_TITLE_TASK;
TaskTile.READING_URL_TASK = READING_URL_TASK;

TaskTile.propTypes = StrictPropTypes({
	type: PropTypes.string,
	item: PropTypes.object,
	onClick: PropTypes.func,
	userID: PropTypes.number,
	gridView: PropTypes.bool
});

module.exports = TaskTile;



// WEBPACK FOOTER //
// ./modules/components/utility/TaskTile.js